import { hasValue } from '@vrplatform/utils';
import type { Statement } from '../_types';
import { getStatementTemplate } from './get-statement-template';

export const getNetRevenueLines = <T extends Statement[]>(
  statements: T
): T[number]['lines'] => {
  const statementTemplate = getStatementTemplate(statements);

  const netRevAccounts = (
    statementTemplate?.data?.netRevenueSections[0]?.columns || []
  )
    .flatMap((c) => (c.type === 'sumAccounts' ? c.value : undefined))
    .filter(hasValue);

  return statements
    .flatMap((statement) => statement?.lines)
    .filter(
      (line) =>
        netRevAccounts.includes(line?.group?.remoteId || '') &&
        !line.isOwnerPayout
    );
};
